import { useContext } from 'react';

import { TranslatorContext, TranslatorContextValue } from '../components/TranslatorContext';

export function useTranslator(): TranslatorContextValue {
    const value = useContext(TranslatorContext);

    return value;
}
